import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SITE_URL = "https://catwomaniya.xyz"

const SEO = ({ description, lang, meta, title, type, datePublished, slug }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            social {
              twitter
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const canonical = slug ? `${SITE_URL}${slug}` : SITE_URL

  // JSON-LD structured data
  const jsonLd = type === "article"
    ? {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        "headline": title,
        "description": metaDescription,
        "url": canonical,
        "datePublished": datePublished || undefined,
        "author": {
          "@type": "Person",
          "name": "Shweta Das",
          "url": SITE_URL,
          "sameAs": [
            "https://www.instagram.com/catwomaniya_",
            "https://x.com/dalekno99"
          ]
        },
        "publisher": {
          "@type": "Person",
          "name": "Shweta Das",
          "url": SITE_URL
        },
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": canonical
        }
      }
    : {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "catwomaniya",
        "description": metaDescription,
        "url": SITE_URL,
        "author": {
          "@type": "Person",
          "name": "Shweta Das",
          "sameAs": [
            "https://www.instagram.com/catwomaniya_",
            "https://x.com/dalekno99"
          ]
        },
        "potentialAction": {
          "@type": "ReadAction",
          "target": `${SITE_URL}/rss.xml`
        }
      }

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={[
        { rel: "canonical", href: canonical },
        { rel: "alternate", type: "application/rss+xml", title: "catwomaniya RSS", href: `${SITE_URL}/rss.xml` },
      ]}
      meta={[
        { name: `description`, content: metaDescription },
        { property: `og:title`, content: title },
        { property: `og:description`, content: metaDescription },
        { property: `og:type`, content: type === "article" ? "article" : "website" },
        { property: `og:url`, content: canonical },
        { name: `twitter:card`, content: `summary` },
        { name: `twitter:creator`, content: site.siteMetadata.social.twitter },
        { name: `twitter:title`, content: title },
        { name: `twitter:description`, content: metaDescription },
      ].concat(meta)}
    >
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  type: `website`,
  datePublished: null,
  slug: null,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  datePublished: PropTypes.string,
  slug: PropTypes.string,
}

export default SEO
